<template>
  <label
    class="small-sec-voucher"
    :for="'card-no' + voucher.cardNo"
    @click="selectVoucher(voucher)"
  >
    <div class="small-voucher-content">
      <ul class="small-voucher-field">
        <li>
          <span class="small-voucher-desc">{{ voucher.holderName }}：</span
          >{{ voucher.cardType | cardType }}
        </li>
        <li>
          <span class="small-voucher-desc">卡号：</span
          >{{ voucher.cardNo | dotted }}
        </li>
      </ul>
      <div class="small-voucher-radio"></div>
    </div>
  </label>
</template>
<script>
export default {
  props: {
    voucher: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  methods: {
    selectVoucher (voucher) {
      this.$emit('selected', voucher, this.index);
    }
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.small-sec-voucher {
  position: relative;
  box-sizing: border-box;
  display: block;
  margin: 0.5rem;
  border-radius: 0.5rem;
  background: url() center left no-repeat;
  background-size: 21px 60px;
  background-color: #fff;
  padding: 0.4rem 0;
  &.selected {
    background-image: url(../../../static/img/voucher-label.png);
    box-shadow: 0px 0px 0px 1.5px $main-style-color inset;
    .small-voucher-radio {
      background-image: url(../../../static/img/choice-success.png);
    }
    .small-voucher-desc {
      display: inline-block;
      color: $main-style-color;
    }
    .small-voucher-content {
      position: relative;
      .small-voucher-field {
        margin-left: 1.75rem;
        padding: 0.25rem 0;
        li {
          color: $main-style-color;
          line-height: initial;
        }
      }
    }
  }
  &.disabled {
    background-image: url(../../../static/img/voucher-label-disabled.png);
    box-shadow: none;
    .small-voucher-radio {
      background-image: url(../../../static/img/choice-define.png);
    }
  }
  // 内容部分
  .small-voucher-content {
    position: relative;
    .small-voucher-field {
      margin-left: 1.75rem;
      padding: 0.25rem 0;
      li {
        line-height: initial;
      }
    }
  }
  .small-voucher-desc {
    display: inline-block;
    color: $main-gray;
  }
  // 选择按钮
  .small-voucher-radio {
    position: absolute;
    width: 22.5px;
    top: 0;
    right: 10px;
    bottom: 0;
    background: url() center left no-repeat;
    background-size: contain;
  }
}
</style>


// WEBPACK FOOTER //
// VoucherItemSmall.vue?0df3baf8